import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "avatar-dropdown"
};
const _hoisted_2 = {
  class: "user-name"
};
const _hoisted_3 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_avatar = _resolveComponent("el-avatar");
  const _component_vab_icon = _resolveComponent("vab-icon");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createBlock(_component_el_dropdown, {
    onCommand: $setup.handleCommand,
    onVisibleChange: $setup.handleVisibleChange
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        command: "personalCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "user-line"
        }), _createElementVNode("span", null, _toDisplayString($setup.translate('个人中心')), 1 /* TEXT */)]),
        _: 1 /* STABLE */
      }), _createVNode(_component_el_dropdown_item, {
        command: "logout"
      }, {
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "logout-circle-r-line"
        }), _createElementVNode("span", null, _toDisplayString($setup.translate('退出登录')), 1 /* TEXT */)]),
        _: 1 /* STABLE */
      })]),
      _: 1 /* STABLE */
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_avatar, {
      class: "user-avatar",
      src: $setup.avatar
    }, null, 8 /* PROPS */, ["src"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
      class: "hidden-xs-only",
      title: $setup.username
    }, _toDisplayString($setup.username), 9 /* TEXT, PROPS */, _hoisted_3), _createVNode(_component_vab_icon, {
      class: _normalizeClass(["vab-dropdown", {
        'vab-dropdown-active': $setup.active
      }]),
      icon: "arrow-down-s-line"
    }, null, 8 /* PROPS */, ["class"])])])]),
    _: 1 /* STABLE */
  });
}